import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=97f3ebf4&scoped=true&"
import script from "./AddQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f3ebf4",
  null
  
)

export default component.exports